import moment, { unitOfTime } from "moment";

const formatDateEnding = (num: number, str: string): string => {
  if (num === 1) {
    return `${num} ${str}`;
  }

  return `${num} ${str}s`;
};

export const howAgoDateDifference = (
  startDate: Date,
  endDate: Date
): string => {
  const start = moment(startDate);
  const end = moment(endDate);

  const years = end.diff(start, "years");
  start.add(years, "years");
  const months = end.diff(start, "months");
  start.add(months, "months");
  const days = end.diff(start, "days");
  let result = [];
  if (!!years) {
    result.push(formatDateEnding(years, "year"));
  }

  if (!!months) {
    result.push(formatDateEnding(months, "month"));
  }

  if (!!days) {
    result.push(formatDateEnding(days, "day"));
  }

  return result.join(", ");
};

export const getOneDateItemDuration = (
  dateItem: unitOfTime.Diff,
  d: Date,
  withFormat?: boolean
) => {
  const today = moment().endOf("day");
  const diff = today.diff(d, dateItem);

  return withFormat ? `${formatDateEnding(diff, dateItem)}` : diff;
};

export const formatDateDDMMYYYY = (dateStr?: string | null): string => {
  if (!dateStr || dateStr === "N/A" || dateStr === "-") return dateStr || "N/A";
  const str = String(dateStr).trim();
  if (/^\d{2}-\d{2}-\d{4}$/.test(str)) return str;
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
    return str.replace(/\//g, "-");
  }
  const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, yyyy, mm, dd] = isoMatch;
    return `${dd}-${mm}-${yyyy}`;
  }
  const parsedDate = new Date(str);
  if (!isNaN(parsedDate.getTime())) {
    const dd = String(parsedDate.getDate()).padStart(2, "0");
    const mm = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const yyyy = parsedDate.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }
  return str;
};
